import { Trans } from 'react-i18next'

import { useAppSelector } from '@/hooks/store.ts'
import {
  usePolicyElements,
  UsePolicyElementsProps,
} from '@/hooks/usePolicyElements'
import { appSlice } from '@/store/appSlice'
import { configSelector } from '@/store/selectors/configSelector.ts'
import { getPolicyI18nKey } from '@/utils/getPolicyI18nKey.ts'

export type PolicyTextVariant = 'disclaimer' | 'checkbox'

export interface PolicyTextContentProps extends UsePolicyElementsProps {
  regulation?: string
  variant?: PolicyTextVariant
}

export const PolicyTextContent = ({
  variant = 'disclaimer',
  ...props
}: PolicyTextContentProps) => {
  const config = useAppSelector(configSelector)
  const isPool = useAppSelector(appSlice.selectors.isPool)

  const policyI18nKey = getPolicyI18nKey({
    beachPrivacyPolicy: props.beachPrivacyPolicy,
    regulation: props.regulation,
  })

  const keySuffix = isPool ? '_pool' : '_beach'
  const checkboxSuffix = variant === 'checkbox' ? 'Checkbox' : ''
  const tOptions = { brandName: config.brandName }

  const {
    OpenPrivacyPolicyAnchor,
    OpenBeachPrivacyPolicyAnchor,
    OpenTermsAnchor,
    OpenBookingPolicyDialogButton,
    OpenRefundPolicyDialogButton,
  } = usePolicyElements(props)

  switch (policyI18nKey) {
    case 'summary.privacy':
      return (
        <Trans
          i18nKey={`${policyI18nKey}${checkboxSuffix}${keySuffix}`}
          tOptions={tOptions}
        >
          {OpenPrivacyPolicyAnchor}
          {OpenBeachPrivacyPolicyAnchor}
          {OpenTermsAnchor}
          {OpenBookingPolicyDialogButton}
          {OpenRefundPolicyDialogButton}
        </Trans>
      )

    case 'summary.smallPrivacy':
      return (
        <Trans
          i18nKey={`${policyI18nKey}${checkboxSuffix}${keySuffix}`}
          tOptions={tOptions}
        >
          {OpenPrivacyPolicyAnchor}
          {OpenTermsAnchor}
          {OpenRefundPolicyDialogButton}
        </Trans>
      )

    case 'summary.privacyWithRegulation':
      return (
        <Trans
          i18nKey={`${policyI18nKey}${checkboxSuffix}${keySuffix}`}
          tOptions={tOptions}
        >
          {OpenPrivacyPolicyAnchor}
          {OpenTermsAnchor}
          {OpenBookingPolicyDialogButton}
          {OpenRefundPolicyDialogButton}
        </Trans>
      )

    case 'summary.privacyWithBeachPolicy':
      return (
        <Trans
          i18nKey={`${policyI18nKey}${checkboxSuffix}${keySuffix}`}
          tOptions={tOptions}
        >
          {OpenPrivacyPolicyAnchor}
          {OpenBeachPrivacyPolicyAnchor}
          {OpenTermsAnchor}
          {OpenRefundPolicyDialogButton}
        </Trans>
      )
  }
}
